<template>
  <div>
    <list row-key="DeviceLogId" ref="list" unit="车载设备" :expand-all-row="true" :page="page" :query-params="params"
      :show-checkbox="$permission.canDel()" :show-query="showQuery" :get-data-func="api.list" @reset="reset">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="归属机构">
          <tree-select ref="treeSelect" :props="props" :options="TreeData" :value="null"
            :clearable="true" :accordion="true" :parentSelect="true" placeholder="请选择"
            @node-select="onTreeSelect($event)" />
        </el-form-item>
       <el-form-item label="车牌号">
          <el-input   v-model="params.CarNo" placeholder="请填写车牌号" clearable />
        </el-form-item>
          <el-form-item label="设备编号">
          <el-input   v-model="params.DeviceNo" placeholder="请填写设备编号" clearable />
        </el-form-item>
        <el-form-item label="设备型号">
          <el-select v-model="params.DeviceModel" clearable>
            <el-option v-for="item in modelList" :key="item.DataName" :value="item.DataName" />
          </el-select>
        </el-form-item>
         <el-form-item label="采集状态">
          <el-select   v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="采集中" :value="0"></el-option>
            <el-option label="采集成功" :value="1"></el-option>
            <el-option label="采集失败" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采集日期">
          <el-date-picker v-model.trim="params.DateStart" placeholder="请选择日期" value-format="yyyy-MM-dd"
            style="width: 193px"></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker v-model.trim="params.DateEnd" placeholder="请选择日期" value-format="yyyy-MM-dd"
            style="width: 193px"></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="归属机构" min-width="160" />
        <el-table-column prop="CarNo" label="车牌号" />
        <el-table-column prop="DeviceNo" label="设备号" />
        <el-table-column prop="DeviceModel" label="设备型号"/>
        <el-table-column prop="ImeiMac" label="IMEI/MAC" />
        <el-table-column prop="FileUrl" label="日志文件">
          <template slot-scope="{row}">
            <el-link v-if="row.FileUrl" @click="downLoad(row)">下载</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="FileSizeMB" label="文件大小(MB)">
          <template slot-scope="{row}">
            <span v-if="row.FileUrl">{{row.FileSizeMB}}</span>
          </template>
        </el-table-column>
       <el-table-column prop="LogDate" label="采集时间" min-width="110">
         <template slot-scope="{row}">
           {{$commonJs.toDateString(row.LogDate)}}
         </template>
       </el-table-column>
       <el-table-column prop="FinishTime" label="完成时间" min-width="140" />
       <el-table-column prop="Remark" label="备注" />
       <el-table-column prop="LogType" label="采集类型" width="80" align="center">
        <template slot-scope="{row}">
          <span v-if="row.LogType==0">日志</span>
          <span type="success" v-else-if="row.LogType==1">数据库</span>
        </template>
       </el-table-column>
       <el-table-column prop="Status" label="采集状态" width="80" align="center">
        <template slot-scope="{row}">
          <el-tag type="priamry" v-if="row.Status==0">采集中</el-tag>
          <el-tag type="success" v-else-if="row.Status==1">成功</el-tag>
          <el-tag type="danger" v-else-if="row.Status==2">失败</el-tag>
        </template>
       </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
  var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  import treeSelect from "@/components/common/treeSelect";

  export default {
    mixins: [listMixin],
    components: { list, treeSelect },
    data() {
      return {
        api: require("@/api/op/devicelog").default,
        basicApi: require("@/api/basic/data").default,
        dpApi: require("@/api/basic/dp").default,
        params: {
          Status: null,
          DpIdChain: "",
          DeviceModel: null,
          DeviceNo: null,
          CarNo: null,
          DateStart: "",
          DateEnd: "",
        },
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
        TreeData: [],
        modelList: [],//设备型号
      };
    },
    beforeMount() {
      this.dpApi.getAuthList({ DpTypes: [2,3,4,5], Status: 3, NoReturnParent: true }).then((res) => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
      });
      this.basicApi.list({ ClassName: "设备型号", Status: 1 }).then(res => {
        this.modelList = res.Data
      });
    },
    methods: {
      onTreeSelect(t) {
        if (!t) {
          this.params.DpIdChain = "";
        } else {
          this.params.DpIdChain = t.IdChain;
        }
      },
      onExport() {
        this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
      },
      reset() {
        this.$refs.treeSelect.clearHandle();
      },
      downLoad(row) {
        window.open(window.location.origin + "/api" + row.FileUrl);
      },
      delRange(Ids) {
        this.api.delete({ Ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
</script>